import styled from 'styled-components'

export const Container = styled.div`
    height: 100%;
    margin: 0 0px;
    /* background-color: white; */
    width: 235px;
    flex: 1;
    /* border: 1px solid #f0f0f0; */
`